import { createTheme, createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { COLORS } from "constants/colors";
import { PapsService } from "generated/graphql";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      backgroundColor: "rgba(64, 180, 229, 0.25)",
      flexDirection: "row",
      height: "52px",
      width: "140px",
      marginLeft: "12px",
      "&:hover": {
        background: "rgba(64, 180, 229, 0.25)",
      },
    },
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      width: "100%",
      height: "80%",
      marginBottom: 0,
      paddingTop: "60px",
    },
    MapContainer: {
      width: "30%",
      height: "100%",
    },
    left: {
      margin: theme.spacing(2),
      height: "100%",
    },
    top: {
      display: "flex",
      marginTop: "12px",
      [theme.breakpoints.down("xs")]: {
        marginTop: 0,
      },
    },
    filterStyle: {
      color: COLORS.primary,
      fontFamily: "Montserrat",
      fontWeight: "bold",
    },
    taskDetail: {
      background: "#fff",
      padding: "10px 0 8px",
      borderRadius: "10px",
      width: "100%",
      top: "89px",
      right: "7px",
      height: "95%",
      paddingBottom: "100px",
      paddingRight: "16px",
      paddingLeft: "16px",
      overflow: "hidden",
      overflowY: "scroll",
      [theme.breakpoints.down("xs")]: {
        position: "initial",
        marginLeft: 0,
        background: "#FFF",
        width: "92vw",
      },
    },
    gridTask: {
      padding: "2px 10px",
      height: "100vh",
      [theme.breakpoints.down("xs")]: {
        padding: "3px 1px 9px 0px",
      },
    },
    bottom: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "15px",
      paddingBottom: "0vh",
      height: "85vh",
    },
    details: {
      borderRadius: 17,
      position: "absolute",
      height: 126,
      width: "30.4%",
      flexGrow: 0,
      marginTop: 21,
      backgroundColor: COLORS.white,
      marginLeft: "10px",
    },
    grid: {
      width: 300,
      height: 180,
      borderRadius: 20,
      backgroundColor: COLORS.white,
      marginLeft: 10,
      marginRight: 10,
    },
    mapStyle: {
      position: "relative",
    },
    contain: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        display: "grid",
      },
    },
    titleTask: {
      fontSize: "24px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#1a224b",
      [theme.breakpoints.down("xs")]: {
        fontSize: "17px",
      },
    },
    searchFilter: {
      textAlign: "left",
      display: "flex",
      justifyContent: "end",
      marginTop: 20,
      marginBottom: 15,
      [theme.breakpoints.down("xs")]: {
        margin: "18px 6px 0px 0px",
      },
    },
    searchDateTask: {
      marginTop: "20px",
      marginBottom: "6px",
    },
    textField: { width: "24rem" },
    searchDate: { display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "16px" },
    table: {
      display: "grid",
      height: "67%",
      marginTop: -10,
      " & .MuiTableRow-head": {
        "& .MuiTableCell-head:first-child": {
          paddingLeft: "20px",
          borderBottomLeftRadius: "5px",
          borderTopLeftRadius: "5px",
        },
        "& .MuiTableCell-head:nth-last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
        },
        "& .MuiTableCell-head:last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
          border: "none",
        },
      },
      " & .MuiTableRow-root": {
        "& > td": {
          paddingBottom: "6px",
          paddingTop: "6px",
          borderTop: "1px solid rgba(64, 180, 229, 0.25)",
          borderBottom: "1px solid rgba(64, 180, 229, 0.25)",
        },
        "& .MuiTableCell-root:first-child": {
          borderRadius: "10px 0px 0px 10px",
          borderLeft: "1px solid rgba(64, 180, 229, 0.25)",
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "1px solid rgba(64, 180, 229, 0.25)",
        },
      },
      "& .MuiTableCell-head": {
        marginBottom: "1em",
        height: "50px",
        backgroundColor: COLORS.lightBlue,
        color: COLORS.primary,
      },
      "& .MuiTableRow-head .MuiTableCell-head:first-child": {
        border: "none !important",
      },
      "& .MuiTableRow-root": {
        height: 30,
      },
    },
  })
);
export const useTaskStyles = makeStyles<Theme, { service?: string }>(() =>
  createStyles({
    gridContainer: {
      flexWrap: "nowrap",
    },
    customBadge: {
      backgroundColor: "#fff",
      color: "#f2994a",
      margin: "-2px -16px 0 0",
    },
    customBadgeTR: {
      backgroundColor: "#fff",
      color: "#f2994a",
      margin: "-10px -28px 0 0",
      transform: "none !important",
    },
    TaskIcon: {
      display: "grid",
      justifyContent: "center",
      justifyItems: "center",
      backgroundColor: ({ service }) =>
        (service === PapsService.Mad && "#2f80ed") ||
        (service === PapsService.Msg && "#399ebf") ||
        (service === PapsService.Nt && "#394fbf") ||
        (service === PapsService.Tr && "#259940"),
      width: "75px",
      height: "75px",
      margin: "3px 24px 15px 15px",
      padding: "18px 14px 18px 16px",
      flexGrow: 0,
      borderRadius: "18px",
    },
    taskServiceMsg: {
      width: "233px",
      height: "29px",
      margin: " 12px 0px 17px -35px",
      fontFamily: "Montserrat",
      fontSize: "24px",
      fontWeight: 600,
      color: ({ service }) =>
        (service === PapsService.Mad && "#2f80ed") ||
        (service === PapsService.Msg && "#399ebf") ||
        (service === PapsService.Nt && "#394fbf") ||
        (service === PapsService.Tr && "#259940"),
    },
    addressRegion: {
      width: "135px",
      height: "29px",
      margin: " 12px 111px 17px -30px",
      fontFamily: "Montserrat",
      fontSize: "12px",
      fontWeight: 400,
      color: "#757a93",
      fontStyle: "normal",
    },
    driverInfos: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      width: "255px",
      fontSize: 14,
      fontWeight: 600,
      color: "#399ebf",
    },
    vehiculeType: {
      fontSize: 14,
      fontWeight: 600,
      color: "#399ebf",
    },
    dateAndVehicule: {
      flex: 1,
      height: "80%",
    },
    driverName: {
      marginLeft: "-35px",
      marginTop: "-11px",
      flex: 1,
      fontSize: 14,
      fontWeight: 600,
      color: "#399ebf",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "2.5px",
      textTransform: "capitalize",
    },
    vehicle: {
      marginRight: "-20px",
    },
    createDate: {
      width: "135px",
      height: "83%",
      marginTop: "18px",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 400,
      color: "#757a93",
      fontStyle: "normal",
    },
    renderVehicles: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      "& .vehicleType": {
        marginRight: 10,
      },
      "& .vehicleName": {
        marginRight: -60,
      },
    },
    itemButton: {
      "&:hover": {
        backgroundColor: "#fff",
      },
    },
    axe: {
      marginBottom: "12px",
    },
    axeText: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#399ebf",
    },

    axeHeading: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    taskUid: {
      fontSize: "13px",
      fontWeight: 600,
      color: "#757a93",
    },
    axeLine: {
      width: "269px",
      height: "1px",
      backgroundColor: " rgba(57, 158, 191, 0.2)",
    },
    infosContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 600,
      color: "#399ebf",
      marginBottom: "24px",
    },
    Type: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "& .vehicule-name": {
        marginLeft: "6px",
      },
    },
    vehicules: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      justifyContent: "space-between",
    },
    driver: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "4px",
    },
    titleContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
    },
    timelineDot: {
      height: "18px",
      width: "18px",
      margin: "0px",
    },
    address: {
      marginLeft: "3px",
    },
    addressMad: {
      marginLeft: "3px",
      fontSize: "14px",
      fontWeight: 500,
      color: "#757a93",
    },
    driverInfosContainer: {
      marginTop: "6px",
      marginLeft: "7px",
      display: "flex",
      paddingTop: "7px",
      alignItems: "flex-end",
      justifyContent: "flex-start",
      gap: "3px",
      textTransform: "capitalize",
    },
  })
);
export const styleIcon = createTheme({
  overrides: {
    MuiButton: {
      iconSizeMedium: {
        "& > *:first-child": {
          color: COLORS.primary,
        },
      },
    },
  },
});
